export default __webpack_public_path__ + "static/media/MallInsights.b37a5b43.jpg";